import React, { memo, useRef, useState } from 'react';
import {
  Stack,
  Card,
  Typography,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  TextField,
  Button,
  Divider,
  Icon
} from 'investira.react.components';

const QuestaoCardTipo = memo(props => {
  const { data, value = '', onChange } = props;

  const [comentario, setComentario] = useState('');
  const [anexos, setAnexos] = useState([]);
  const inputArquivoRef = useRef(null);

  const xQuestoes = [
    'Indisponibilidade de classificação ou classificação abaixo dos níveis discriminados na 2ª, 3ª ou 4ª opções a seguir.',
    "Equivalente M3 da Fitch; AMP-3 da S&P; MQ3 da Moody's; LFg3 da LFRatings; ou QG 3 Austin.",
    "Equivalente M2 da Fitch; AMP-2 da S&P; MQ2 da Moody's; LFg2 da LFRatings; ou QG 2 Austin.",
    "Nota equivalente ao M1 da Fitch; AMP-1 da S&P; MQ1 da Moody's; LFg1 da LFRatings; ou QG 1 Austin."
  ];

  const { id, questao } = data;

  const handleChange = pEvent => {
    const xRespostaId = Number(pEvent.target.value);
    const xRespostaTexto = xQuestoes[xRespostaId - 1] || null;
    onChange?.(id, {
      resposta_id: xRespostaId,
      resposta_texto: xRespostaTexto
    });
  };

  const handleAnexarArquivo = () => {
    inputArquivoRef.current?.click();
  };

  const handleArquivoSelecionado = pEvent => {
    const xArquivosSelecionados = Array.from(pEvent.target.files || []);
    if (!xArquivosSelecionados.length) return;

    const xRespostaId = Number(value);
    const xRespostaTexto = xQuestoes[xRespostaId - 1] || null;

    setAnexos(pPrev => {
      const xProximosAnexos = [...pPrev, ...xArquivosSelecionados];
      onChange?.(id, {
        resposta_id: xRespostaId,
        resposta_texto: xRespostaTexto,
        comentario,
        anexos: xProximosAnexos
      });
      return xProximosAnexos;
    });

    pEvent.target.value = '';
  };

  const xTemRespostaSelecionada = Boolean(value);

  return (
    <Card id={id}>
      <Stack gap={2} py={4}>
        <Stack px={4}>
          <Stack mb={1} direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" gap={1} alignItems="center">
              <Typography variant="caption" color="textSecondary">
                Questão {id}
              </Typography>
            </Stack>
          </Stack>
          <Stack mb={2}>
            <Typography variant="body1" color="textPrimary" sx={{ fontWeight: 600 }}>
              {questao}
            </Typography>
          </Stack>
          <FormControl fullWidth>
            <RadioGroup name={`questao-${id}`} value={String(value ?? '')} onChange={handleChange}>
              <Stack gap={2}>
                {xQuestoes.map((xQuestao, xIndex) => (
                  <FormControlLabel
                    key={`questao-${id}-opcao-${xIndex + 1}`}
                    value={String(xIndex + 1)}
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" color="textPrimary">
                        {xQuestao}
                      </Typography>
                    }
                  />
                ))}
              </Stack>
            </RadioGroup>
          </FormControl>
        </Stack>

        <Divider />

        {xTemRespostaSelecionada && (
          <Stack px={4} gap={1.5}>
            <TextField
              variant="outlined"
              fullWidth
              multiline
              minRows={3}
              size="small"
              label="Comentário"
              placeholder="Digite um comentário para esta questão"
              value={comentario}
              onChange={pEvent => setComentario(pEvent.target.value)}
            />
            <input
              ref={inputArquivoRef}
              type="file"
              multiple
              style={{ display: 'none' }}
              onChange={handleArquivoSelecionado}
            />
            <Stack direction="row" justifyContent="flex-end">
              <Button
                variant="outlined"
                onClick={handleAnexarArquivo}
                size="small"
                startIcon={<Icon iconName="paper_clip" size={16} />}>
                Anexar arquivo
              </Button>
            </Stack>
            {anexos.length > 0 && (
              <Stack gap={0.5}>
                {anexos.map((xAnexo, xIndex) => (
                  <Typography
                    key={`${xAnexo.name}-${xIndex}`}
                    variant="caption"
                    color="textSecondary">
                    {xAnexo.name}
                  </Typography>
                ))}
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
    </Card>
  );
});

export default QuestaoCardTipo;
